import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormlyModule } from '@ngx-formly/core';
import { ReactiveFormsModule } from '@angular/forms';
import { ExpansionPanelModule } from '@progress/kendo-angular-layout';

import { FormlyWrapperSimpleFormField } from './form-field.wrapper';
import { FormlyWrapperSimplePanel } from './simple-panel.wrapper';
import { FormlyWrapperExpansionPanel } from './expansionpanel.wrapper';

@NgModule({
    declarations: [
        FormlyWrapperSimpleFormField,
        FormlyWrapperSimplePanel,
        FormlyWrapperExpansionPanel
    ],
    imports: [
        CommonModule,
        ReactiveFormsModule,
        ExpansionPanelModule,

        FormlyModule.forChild({
            wrappers: [
                { name: 'simple-form-field', component: FormlyWrapperSimpleFormField },
                { name: 'simple-panel', component: FormlyWrapperSimplePanel },
                { name: 'kendo-expansionpanel', component: FormlyWrapperExpansionPanel },
            ],
        }),
    ],
})
export class FormlySimpleFormFieldModule { }
